import mixpanel from 'mixpanel-browser';
import { clearLocalStorageKeepingRecordingChoice } from './replay-consent';
import { isNativeCapacitorRuntime } from '../services/nativeRuntime';
import { forgetRevenueCatUser } from '../services/nativeSubscriptionManagement';

export const DELETE_ACCOUNT_PATH = '/user-settings/delete-account';

// The full-page navigation, as an object so tests can observe it (jsdom cannot navigate).
export const pageNavigation = {
  replace: (path) => window.location.replace(path),
};
export const ACCOUNT_DELETED_PATH = '/account-deleted';

// The account is gone on the server; this forgets it on the device. Same clear as the menu's
// Sign out, plus the identities a normal sign-out keeps: Mixpanel's distinct id and, in the app,
// RevenueCat's app user id. The route moves first, so nothing on the delete page acts on the
// cleared session meanwhile. On the web the page then reloads, which also drops in-memory
// identity (the GTM data layer keeps the last user_id for the page's life).
export const signOutAfterDeletion = async ({ dispatch, history }) => {
  dispatch({ type: 'LOGOUT' });
  try {
    mixpanel.reset();
  } catch (_) {
    // Mixpanel not initialised (opted out on iOS by default).
  }
  clearLocalStorageKeepingRecordingChoice();
  try {
    // Per-tab state (an exam in progress, a carried quiz) belongs to the deleted account too.
    window.sessionStorage.clear();
  } catch (_) {
    // Storage unavailable (private mode): nothing to clear.
  }
  history.replace(ACCOUNT_DELETED_PATH);
  if (isNativeCapacitorRuntime()) {
    await forgetRevenueCatUser();
    return;
  }
  pageNavigation.replace(ACCOUNT_DELETED_PATH);
};
